import Vue from "vue";
import Vuex from "vuex";
import * as actions from './actions'
import * as getters from './getters'
import * as mutations from './mutations'
import debounce from 'lodash/debounce';

Vue.use(Vuex);

const store = new Vuex.Store({
    state: {
        breakpoints: {
            tabletLandscape: 980,
            ipadPro: 1025,
            notebook: 1440,
        },
        isMobileNav: false,
        isNotebook: false,
        activeWorkout: false,
        user: null,
        searchTerm: null,
        registrationUser: {
            name: null,
            firstName: null,
            lastName: null,
            sex: null,
            dob: null,
            weight: null,
            height: null,
            location: null,
            profileImageKey: null,
            preferences: {
                workoutInterval: 3,
                workoutTimeOfDay: "20:00",
                workoutDuration: 5400
            },
            goalId: null,
            interestsIds: [],
            goal: {},
            interests: [],
            profileImageUrl: null
        },
        trainers: null,
        averageWeight: 70,
        met: {
            warm_up: 4,
            cool_down: 1.5,
            beginner: 5,
            intermediate: 7,
            advanced: 9,
            fallback: 1
        },
        favourites: null,
        staticWorkouts: [ //remove after christmas
            '2e19401f-163e-43c5-8bc1-ff00cad84f72',
            '76ad8664-5895-4eda-ac5f-97a797b83979',
            // 'e19f6248-b9bb-4a23-94c7-5b2e25d8da2c',
            // '58fde140-a83d-4c7f-b114-1c30a72461ec',
            '0f89fc54-4d3a-4aa6-85c4-b435c4b2141e', //new
            'f3e41779-31f5-4839-8705-9e8ca1d8f242',
            '3aab3640-bb26-4bfb-a458-b36e2019f0d2',
            '5d4bae71-0705-4bc8-baf3-daa017f5fe12',
            '3ff3276f-b565-4c72-83a3-3b7b03dbc2d3',
            '7719fdb0-41f3-46b8-9d69-cdad209d5775',
            'f15ea824-e38d-44a3-b5a7-65d13ec7236f',
            // '79d4ae9b-9089-4764-a366-c4bce2baedce',
            '0e765688-a016-4273-a5ee-b269eb4e0900', //new
            '6541d11f-bf12-413b-8d4a-1127dad750ac',
            '020c109b-7b03-462c-a55e-8824989e7bae',
        ],
        staticWorkoutIds: [
            '2e19401f-163e-43c5-8bc1-ff00cad84f72',
            '76ad8664-5895-4eda-ac5f-97a797b83979',
            // 'e19f6248-b9bb-4a23-94c7-5b2e25d8da2c',
            // '58fde140-a83d-4c7f-b114-1c30a72461ec',
            '0f89fc54-4d3a-4aa6-85c4-b435c4b2141e', //new
            'f3e41779-31f5-4839-8705-9e8ca1d8f242',
            '3aab3640-bb26-4bfb-a458-b36e2019f0d2',
            '5d4bae71-0705-4bc8-baf3-daa017f5fe12',
            '3ff3276f-b565-4c72-83a3-3b7b03dbc2d3',
            '7719fdb0-41f3-46b8-9d69-cdad209d5775',
            'f15ea824-e38d-44a3-b5a7-65d13ec7236f',
            // '79d4ae9b-9089-4764-a366-c4bce2baedce',
            '0e765688-a016-4273-a5ee-b269eb4e0900', //new
            '6541d11f-bf12-413b-8d4a-1127dad750ac',
            '020c109b-7b03-462c-a55e-8824989e7bae',

            //remove cards below after christmas
            'c52a7ae5-ddb6-4424-bca0-b7a0f43b3fa1',
            '23ab7f43-bbf4-41d7-b02f-669947b0defa',
            'fcd06ff5-71cc-43a4-826a-c00b0b6e3d25',
            'fcd06ff5-71cc-43a4-826a-c00b0b6e3d25',
            '7472cb09-21df-47f0-a4f9-a5f478f788a7',
            '604f1a6f-2456-486f-88ba-c21d89abfa26',
            'a7254ff4-16af-4224-9bc4-8ef1b6d9801a',
            '30392c79-73f1-4204-812d-af1a0befc534',
            'e06d14b7-14b6-4830-b28e-f83602b93d2f',
            '5059bd80-59d3-45cd-aceb-76b6156039a6',
            '24059518-228d-45b7-aa77-554cbd630a44',
            'ebd5a5e1-8b92-44fb-8420-476860f064ac',
            '4fdb7b0d-2dfd-41d4-855a-7bf0675304ce',
            '5cb7052b-3247-44d9-a117-3c33ada4b9d6',
            'dfef4266-010e-459c-bb96-cbb98aa1b0a1',
            '1a580948-f8e5-4d86-b3ef-a67d320161c4',
            '88adf0e8-b5cb-4962-8047-b95cb23f8636',
            'd75adcbe-b157-4063-93d4-b89ee61ef42d',
            '76d3a9e3-9e2b-4472-b689-96f3df8f7409',
            'd0621aba-352e-4054-bf07-a69d4b17a77e',
            'd941d6a9-ccd0-4917-8b33-43d1c9972547',
            '7f8aaf4a-7ada-4f75-86cf-92e4e2ac728d',
            '26867321-903a-4e8a-a129-c8fe1f97fd06',
            'c1c3d907-35ee-4ff1-b31a-ab47cbf820a2',
            'ae399f08-c1df-4749-9d4d-52d896b1b681',
        ],
        christmasWorkoutIds: [
            {
                // id: '2e19401f-163e-43c5-8bc1-ff00cad84f72', //to be replaced with chelsea (1 link)
                id: '26867321-903a-4e8a-a129-c8fe1f97fd06', //working now (check category)
                order: 1,
                category: 'HIIT'
            },
            {
                id: 'c52a7ae5-ddb6-4424-bca0-b7a0f43b3fa1',
                order: 2,
                category: 'Dance'
            },
            {
                id: '23ab7f43-bbf4-41d7-b02f-669947b0defa',
                order: 3,
                category: 'Boxing'
            },
            {
                id: 'fcd06ff5-71cc-43a4-826a-c00b0b6e3d25',
                order: 4,
                category: 'Pilates'
            },
            // {
            //     id: '76ad8664-5895-4eda-ac5f-97a797b83979', //test only remove
            //     order: 5,
            //     category: 'HIIT'
            // },
            {
                id: '7472cb09-21df-47f0-a4f9-a5f478f788a7', //working now
                order: 5,
                category: 'HIIT'
            },
            {
                id: '604f1a6f-2456-486f-88ba-c21d89abfa26',
                order: 6,
                category: 'Run'
            },
            {
                // id: '3aab3640-bb26-4bfb-a458-b36e2019f0d2', //to be replaced with chelsea (2 link)
                id: 'c1c3d907-35ee-4ff1-b31a-ab47cbf820a2', //working now
                order: 7,
                category: 'Yoga'
            },
            {
                id: 'a7254ff4-16af-4224-9bc4-8ef1b6d9801a', //working now
                order: 8,
                category: 'Dance'
            },
            {
                id: '30392c79-73f1-4204-812d-af1a0befc534',
                order: 9,
                category: 'Boxing'
            },
            {
                id: 'e06d14b7-14b6-4830-b28e-f83602b93d2f',
                order: 10,
                category: 'Yoga'
            },
            {
                id: '5059bd80-59d3-45cd-aceb-76b6156039a6',
                order: 11,
                category: 'HIIT'
            },
            {
                id: '24059518-228d-45b7-aa77-554cbd630a44',
                order: 12,
                category: 'HIIT'
            },
            {
                id: 'ebd5a5e1-8b92-44fb-8420-476860f064ac',
                order: 13,
                category: 'Run'
            },
            {
                id: '4fdb7b0d-2dfd-41d4-855a-7bf0675304ce',
                order: 14,
                category: 'Run'
            },
            // {
            //     id: 'f15ea824-e38d-44a3-b5a7-65d13ec7236f', //test only remove
            //     order: 15,
            //     category: 'Boxing'
            // },
            {
                id: '5cb7052b-3247-44d9-a117-3c33ada4b9d6', //working now
                order: 15,
                category: 'Boxing'
            },
            {
                id: 'dfef4266-010e-459c-bb96-cbb98aa1b0a1',
                order: 16,
                category: 'Pilates'
            },
            {
                id: '1a580948-f8e5-4d86-b3ef-a67d320161c4', //added now
                order: 17,
                category: 'Run'
            },
            {
                id: '88adf0e8-b5cb-4962-8047-b95cb23f8636',
                order: 18,
                category: 'Run'
            },
            {
                // id: '5d4bae71-0705-4bc8-baf3-daa017f5fe12', //to be replaced with danielle (1 link) n19
                id: 'ae399f08-c1df-4749-9d4d-52d896b1b681', //working now
                order: 19,
                category: 'Yoga'
            },
            {
                id: 'd75adcbe-b157-4063-93d4-b89ee61ef42d',
                order: 20,
                category: 'Dance'
            },
            {
                id: '76d3a9e3-9e2b-4472-b689-96f3df8f7409',
                order: 21,
                category: 'Boxing'
            },
            // {
            //     id: '0e765688-a016-4273-a5ee-b269eb4e0900', //test only remove
            //     order: 22,
            //     category: 'Yoga'
            // },
            {
                id: 'd0621aba-352e-4054-bf07-a69d4b17a77e', //working now
                order: 22,
                category: 'Yoga'
            },
            // {
            //     id: '020c109b-7b03-462c-a55e-8824989e7bae', //test only remove
            //     order: 23,
            //     category: 'HIIT'
            // },
            {
                id: 'd941d6a9-ccd0-4917-8b33-43d1c9972547', //working now
                order: 23,
                category: 'HIIT'
            },
            {
                id: '7f8aaf4a-7ada-4f75-86cf-92e4e2ac728d', //working now
                order: 24,
                category: 'HIIT'
            },
        ],
        filters: {
            levels: [],
            goals: [],
            interests: [],
            duration: {},
            trainers: []
        },
        goals: [],
        interests: [],
        reasons:[],
    },
    actions,
    getters,
    mutations,
    modules: {}
});

window.addEventListener(
    'resize',
    debounce(() => {
        store.dispatch('checkIfMobileNav');
        store.dispatch('checkIfNotebook');
        store.dispatch('setWindowHeight');
    }, 200),
);

export default store;